import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {
  intregtedAccount: any = []
  gscAccount: any = []
  uid: string = ""
  wbSite: any = ''
  wordPressUserName: any = ''
  password2: any = ''
  closeResult!: string;
  isLoading : boolean = false;
  accessToken:string="";
  @ViewChild('loginRef', {static: true }) loginElement: ElementRef | undefined;
  isAuthorized:boolean =false;
  theme: boolean = false;
  constructor(
    private toastr: ToastrService, 
    private modalService: NgbModal, 
    private editorServie: EditorService, 
    private cookieServ: CookieService, 
    private router: Router,
    private route: ActivatedRoute,
    private themingService:ThemingService,
    // private authService: SocialAuthService
    ) 
    { 
      this.themingService.getThemeName().subscribe((res: any) => {
        this.theme = res;
      })
    }

  ngOnInit(): void {
    this.themingService.pingThemeName();
    this.uid = this.cookieServ.get("uid");
    // this.uid = "u-0b41030a-fa26-11ed-84d6-bb490d2813ff";
    if (!this.uid || !localStorage.getItem('auth_token')) {
      this.router.navigate([`login`])
    } else {
      // this.editorServie.getGsc().subscribe(res=>{
      //   if(!!res && !!res.data && res.data.length > 0){
      //     localStorage.setItem('google_refresh_token',JSON.stringify(res.data[0]?.access_token));
      //   }
      // })
      this.getIntreGretedAccount('wordpress')
      this.getIntreGretedAccount('GSC')
    }
    this.editorServie.getErrorFlag().subscribe(res=>{
      this.clearData()
    });
    this.route.queryParams.subscribe((params:any) => {
      const code = params['code'];
      const state = params['state'];

      if(code){
        this.isAuthorized = false;
        this.accessToken = code;
      }
      this.editorServie.getToken(code).subscribe((res:any)=>{
        localStorage.setItem('google_token',JSON.stringify(res.access_token));
        if(state && state!==undefined && state!=='undefined'){
          this.router.navigate([`/dashboard/content-editor/editor/${state}`])
        }
        // if(res.refresh_token){
        //   this.editorServie.storeGsc({access_token:res.refresh_token}).subscribe(ress=>{
        //   })
        // }
        // this.accessToken = res.access_token;
        // this.getSiteLists();
        // this.initGraphs();

      });
      this.accessToken =JSON.parse(localStorage.getItem('google_token') || '');
    });
  }
  getIntreGretedAccount(type:any) {
    this.wbSite = ''
    this.wordPressUserName = ''
    this.password2 = ''
    this.isLoading = true
    this.editorServie.getIntregratedAccount({ uid: this.uid,"type":type }).subscribe((res) => {
      if(type == "wordpress"){
        this.intregtedAccount = res.account
      }else{
        this.gscAccount = res.account
      }
      this.isLoading = false
    })
  }
  addAccount() {
    var btn = (document.getElementById("confirmBtn")as any);
    if (!this.wordPressUserName) {
      this.toastr.error('Please fill out WordPress Site Domain')
      return
    }
    if (!this.password2) {
      this.toastr.error('Please fill out WordPress Application Password')
      return
    }
    if (!this.wbSite) {
      this.toastr.error('Please fill out WordPress Username')
      return
    }
    if (!!this.wordPressUserName && !!this.password2 && !!this.wbSite && !!this.uid) {
      if (!!this.wbSite && this.wbSite != "") {
        this.wbSite = this.getDomain(this.wbSite, true)
      }
      let Obj = {
        username: this.wordPressUserName,
        password: this.password2,
        website: this.wbSite,
        uid: this.uid
      }
      let _Obj: any = {
        password: this.password2,
        username: this.wordPressUserName,
        website: this.wbSite,
        title: "title",
        content: "test",
      }
      this.isLoading = true
      btn.disabled = true;
      this.editorServie.checkCrediantial(_Obj).subscribe((res: any) => {
        if (res?.success) {
          // let Obj = {
          //   username: this.wordPressUserName,
          //   password: this.password2,
          //   website: this.wbSite,
          //   uid: this.uid
          // }
          this.editorServie.addIntregratedAccount(Obj).subscribe((res: any) => {
            this.isLoading = false
            if(res?.message && res?.message == "The WordPress site is already connected." ){
                this.toastr.error("The WordPress site is already connected.");
                this.wbSite = ''
                this.wordPressUserName = ''
                this.password2 = ''
                this.getIntreGretedAccount('wordpress')
                btn.disabled = false;
                this.modalService.dismissAll();
            }else{
              if (res) {
                this.wbSite = ''
                this.wordPressUserName = ''
                this.password2 = ''
                this.getIntreGretedAccount('wordpress')
                this.toastr.success("The WordPress site has been successfully connected.");
                btn.disabled = false;
                this.modalService.dismissAll();
              } else {
                this.toastr.success('getting error when intgerated account')
                btn.disabled = false;
              }
            }
          })
        } else {
          this.toastr.error("The WordPress site is NOT connected due to incorrect credentials.")
          btn.disabled = false;
        }
      })
    }

  }

  clearData(){
    var btn = (document.getElementById("confirmBtn")as any);
    this.isLoading = false
    btn.disabled = false;
    this.password2 = ""
    this.wordPressUserName = ""
    this.wbSite = ""
  }

  deleteWordPressAccount(accountId: any) {
    this.isLoading = true
    this.editorServie.deleteIntregratedAccount({ accountId: accountId }).subscribe((res) => {
      this.isLoading = false
      if (res) {
        this.getIntreGretedAccount('wordpress')
      }
    })
  }
  getDomain(url: any, subdomain: any) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, '');

    if (!subdomain) {
      url = url.split('.');

      url = url.slice(url.length - 2).join('.');
    }

    if (url.indexOf('/') !== -1) {
      return url.split('/')[0];
    }

    return url;
  }
  open(content: TemplateRef<any>) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title',size:'xl' }).result.then(
      (result: any) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }
  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }



  authorize() {
    // this.isAuthorized = true;
    this.isAuthorized = true;

    // const authUrl: any = this.editorServie.authorizes();
    // window.location.href = authUrl;
  }
  authorizeGsc(){
    // const authUrl: any = this.editorServie.authorizes();
    // window.location.href = authUrl;
    const authUrl: any = this.editorServie.authorizes();
    window.location.href = authUrl;
    // this.router.navigate(['/dashboard/integration-gsc'])
  }

  navigateToGsc(){
    // this.isAuthorized = true;
    this.router.navigate(['/dashboard/integration-gsc'])
  }
}
